module.exports = __webpack_public_path__ + "img/chart.907b61f5.svg";